import { render, staticRenderFns } from "./CockpitMatryoshkaColumnQueueItem.vue?vue&type=template&id=204ed847&scoped=true"
import script from "./CockpitMatryoshkaColumnQueueItem.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaColumnQueueItem.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaColumnQueueItem.vue?vue&type=style&index=0&id=204ed847&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ed847",
  null
  
)

export default component.exports